import { useScenarioBuilderClient } from "@/pages/scenario-builder/api/hooks/useScenarioBuilderClient";
import { ActionPlanDetail } from "@mutiny-group/sbo-openapi-client";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useAnalytics } from "@/hooks/useAnalytics";
import dayjs from "dayjs";

type UseDownloadSpendingPlanOptions = {
  actionPlan: ActionPlanDetail;
};

export const useDownloadSpendingPlan = ({ actionPlan }: UseDownloadSpendingPlanOptions) => {
  const scenarioBuilderClient = useScenarioBuilderClient();
  const { spendingPlanDownloaded } = useAnalytics();
  return useMutation({
    mutationKey: ["download-spending-plan", actionPlan?.uuid],
    mutationFn: () =>
      scenarioBuilderClient.actionPlans.downloadActionPlanData({
        actionPlanUuid: actionPlan.uuid,
      }),
    onSuccess: (data: string) => {
      downloadSpendingPlan(data, actionPlan.name);
      toast.success("Spending plan downloaded successfully");
      spendingPlanDownloaded({
        actionPlanId: actionPlan.uuid,
        actionPlanName: actionPlan.name,
        actionPlanLength: dayjs(actionPlan.endDate).diff(dayjs(actionPlan.startDate), "months"),
        actionPlanSpend: actionPlan.spendPlannedTotal,
        actionPlanStatus: actionPlan.status,
        actionPlanRevenueGoal: actionPlan.revenueTarget,
        actionPlanRevenueForecast: actionPlan.revenueForecastToDate,
      });
    },
    onError: () => {
      toast.error("Failed to download spending plan");
    },
  });
};

export const downloadSpendingPlan = (spendingPlan: string, name: string) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([spendingPlan]));
  a.download = `${name}_spending_plan.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
};
